import { request } from './reducers/get';

// eslint-disable-next-line import/no-default-export
export default {
    PERMISSIONS_GET_REQUEST: request,
};
